// extracted by mini-css-extract-plugin
export var button = "medIntegrationSection-module--button--65a97";
export var container = "medIntegrationSection-module--container--17e54";
export var content = "medIntegrationSection-module--content--aca33";
export var description = "medIntegrationSection-module--description--7704e";
export var link = "medIntegrationSection-module--link--81c26";
export var logos = "medIntegrationSection-module--logos--47ee1";